import script from "./ParempiGrid.ts?vue&type=script&lang=ts&external"
export * from "./ParempiGrid.ts?vue&type=script&lang=ts&external"

import "./ParempiGrid.vue?vue&type=style&index=0&id=4e07e0f3&lang=scss"

const __exports__ = script;

export default __exports__